import { IApplicationState } from '../../../../../../types/types';

export const getActiveNotification = (
    state: IApplicationState
): number => {
    return state.notifications.activeNotification;
};
